module.exports = __webpack_public_path__ + "img/fubo_keep.9abfed04.png";